import { Component, inject, Input } from '@angular/core';
import { map, Observable } from 'rxjs';

import { RouteBreadcrumbs, RouteTitleModel } from 'src/app/interfaces/route-title';
import { MaybeNull } from 'src/app/utils';
import { RouteTitleService } from '../../services/route-title.service';

@Component({
  selector: 'app-route-title',
  templateUrl: './route-title.component.html',
  styleUrls: ['./route-title.component.scss'],
})
export class RouteTitleComponent {
  @Input({ required: true }) iconRef: string;
  @Input({ required: true }) defaultTitle: string;
  @Input({ required: true }) dataTestId: string;

  public readonly breadcrumbs$: Observable<MaybeNull<RouteBreadcrumbs>> = inject(RouteTitleService).routeTitle$.pipe(
    map((title: MaybeNull<RouteTitleModel>) => title?.breadcrumbs ?? null),
  );
}
